








import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';

@Component({})
export default class TopMenu extends Vue {
    @Prop({required: true})
    public strength: number;
}
